import store from '@/store'
import { get } from 'lodash-es'
import { modelStateRegistry } from '@/utils/modelStateRegistry'
import { getToddsModelDescription, getToddsModelName, getToddsModelIds, getToddsModelUnit } from './toddsModelMetadata'
import { getToddsModelColumnGroups } from './toddsModelsColumnGroups'
import { buildToddsModelsColumnDef } from './toddsModelsColumnsDef'
import {
  formatConstructedError,
  defaultResultsKey,
  defaultChemicalKey,
  defaultResultKey,
} from '@/utils/responseNormalizers'

const groupedKeys = get(modelStateRegistry, 'groupedModel.keys')
const namespace = 'toddsModels'

const getToddsModelAdapter = (modelId) => ({
  [modelId]: {
    predictionsKey: defaultResultKey,
    chemicalKey: defaultChemicalKey,
    errorKey: 'error',
    categoryId: namespace,
    getResults: () => store.getters[`${namespace}/${groupedKeys.getResultsForModel}`](modelId)?.[defaultResultsKey],
    getIsLoading: () => store.getters[`${namespace}/${groupedKeys.getIsLoadingForModel}`](modelId),
    getIsAborted: () => store.getters[`${namespace}/${groupedKeys.getIsAbortedForModel}`](modelId),
    fetch: (chemicals) => store.dispatch(`${namespace}/predict`, { structures: chemicals, modelId }),
    reset: () => store.commit(`${namespace}/${groupedKeys.RESET_STATE_FOR_MODEL}`, modelId),
    abort: () => store.commit(`${namespace}/${groupedKeys.ABORT_CURRENT_FETCH_FOR_MODEL}`, { modelId }), // Aborting is handled in the action by checking the signal
    getParameters: () => getToddsModelColumnGroups(modelId),
    getColumnDefBuilder: buildToddsModelsColumnDef,
    getName: () => getToddsModelName(modelId),
    getDescription: () => getToddsModelDescription(modelId),
    getUnit: () => getToddsModelUnit(modelId),
    formatError: (error) => formatConstructedError(error),
  },
})

const getToddsModelAdapters = () =>
  getToddsModelIds().reduce((acc, modelId) => ({ ...acc, ...getToddsModelAdapter(modelId) }), {})

export { getToddsModelAdapters }
